// Survey template export. Looks up the project's attribute template
// (via projects.template_id or by latest version on the project) and
// hands the schema off to the existing DOCX renderer.

import { supabase } from "@/shared/integrations/supabase/client";
import { exportTemplateToDocx } from "@/features/exports/services/siteAttributeExportUtils";

interface ExportTemplateInput {
  projectId: string;
  projectName: string;
}

export async function exportTemplate(input: ExportTemplateInput): Promise<void> {
  const { data: project, error: projectError } = await supabase
    .from("projects")
    .select("template_id")
    .eq("id", input.projectId)
    .single();

  if (projectError) throw projectError;

  let query = supabase
    .from("attribute_templates")
    .select("schema_definition");

  if (project?.template_id) {
    query = query.eq("id", project.template_id);
  } else {
    query = query
      .eq("organization_id", input.projectId)
      .order("version", { ascending: false })
      .limit(1);
  }

  const { data: template, error } = await query.maybeSingle();
  if (error) throw error;
  if (!template?.schema_definition) {
    throw new Error("This project does not have a survey template configured.");
  }

  await exportTemplateToDocx(template.schema_definition, input.projectName);
}
